import { render } from "./StudentDetail.vue?vue&type=template&id=5e0e9dc6&scoped=true&ts=true"
import script from "./StudentDetail.vue?vue&type=script&lang=ts"
export * from "./StudentDetail.vue?vue&type=script&lang=ts"

import "./StudentDetail.vue?vue&type=style&index=0&id=5e0e9dc6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e9dc6"]])

export default __exports__